import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את היעדר החשק",
    opening: localizedGenderNode(
      [
      "היום אני לא דוחף/ת את עצמי.",
      "אני רק שם/ה לב: אין לי חשק."
    ],
      [
      "היום אני לא דוחף/ת את עצמי.",
      "אני רק שם/ה לב: אין לי חשק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מתי חוסר החשק מורגש הכי חזק?",
      "אני שואל/ת את עצמי, בשקט: מה אני אומר/ת לעצמי ברגעים האלה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מתי חוסר החשק מורגש הכי חזק?",
      "אני שואל/ת את עצמי, בשקט: מה אני אומר/ת לעצמי ברגעים האלה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מרגיש/ה בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גם חוסר חשק הוא חוויה, לא אני."
    ],
      [
      "גם חוסר חשק הוא חוויה, לא אני."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני רואה שאין לי חשק\".",
      "נשימה אחת + \"אני רואה שאין לי חשק\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו זה מתחיל.",
      "אני רק שם/ה לב."
    ],
      [
      "היום אני שם/ה לב לרגע שבו זה מתחיל.",
      "אני רק שם/ה לב."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שהחוסר מתחיל?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי ביום?",
      "אני שואל/ת את עצמי, בשקט: מה אני מנסה להימנע ממנו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה קורה ממש לפני שהחוסר מתחיל?",
      "אני שואל/ת את עצמי, בשקט: איפה זה פוגש אותי ביום?",
      "אני שואל/ת את עצמי, בשקט: מה אני מנסה להימנע ממנו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשזה מתחיל.",
      "נשימה אחת כשזה מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "סימני הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני המחשבה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את חוסר החשק?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איפה הגוף מרגיש את חוסר החשק?",
      "אני שואל/ת את עצמי, בשקט: מה הגוף שלי מנסה להגן?",
      "אני שואל/ת את עצמי, בשקט: מה יכול להתרכך קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף שלי מנסה לשמור עליי."
    ],
      [
      "הגוף שלי מנסה לשמור עליי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "סיפור מול עובדה",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור.",
      "אני לא נלחם/ת בסיפור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה העובדה הפשוטה כאן?",
      "אני שואל/ת את עצמי, בשקט: איזה סיפור קפץ לי?",
      "אני שואל/ת את עצמי, בשקט: איזו אפשרות רכה יכולה להיות נכונה גם היא?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "מה נעלם",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנעלם בי.",
      "לא כדי להאשים."
    ],
      [
      "היום אני שם/ה לב למה שנעלם בי.",
      "לא כדי להאשים."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את כפות הרגליים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל חסר לי?",
      "אני שואל/ת את עצמי, בשקט: מתי אני מרגיש/ה מעט יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מתגעגע/ת אליו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה בדרך כלל חסר לי?",
      "אני שואל/ת את עצמי, בשקט: מתי אני מרגיש/ה מעט יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה אני מתגעגע/ת אליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב למה שנעלם זה כבר קשר."
    ],
      [
      "לשים לב למה שנעלם זה כבר קשר."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב דבר אחד שחסר לי.",
      "לכתוב דבר אחד שחסר לי."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קול פנימי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לקול הפנימי שלי.",
      "בלי להכריח."
    ],
      [
      "היום אני מקשיב/ה לקול הפנימי שלי.",
      "בלי להכריח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרפה את הכתפיים מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה הקול הפנימי שלי אומר על חוסר החשק?",
      "אני שואל/ת את עצמי, בשקט: מה הקול הזה בוחר/ת ממני?",
      "אני שואל/ת את עצמי, בשקט: מה נשמע רך יותר בתוכי?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה הקול הפנימי שלי אומר על חוסר החשק?",
      "אני שואל/ת את עצמי, בשקט: מה הקול הזה בוחר/ת ממני?",
      "אני שואל/ת את עצמי, בשקט: מה נשמע רך יותר בתוכי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול פנימי עדין הוא התחלה."
    ],
      [
      "קול פנימי עדין הוא התחלה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי אחד רך.",
      "משפט פנימי אחד רך."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "צורך קטן",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך שמתחת לחוסר החשק.",
      "אני לא פותר/ת."
    ],
      [
      "היום אני נוגע/ת בצורך שמתחת לחוסר החשק.",
      "אני לא פותר/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ],
      [
      "אני מניח/ה יד על החזה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש קצת יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה אני בוחר/ת/ה כדי להרגיש קצת יותר חי/ה?",
      "אני שואל/ת את עצמי, בשקט: מה בי מבקש חום או קרבה?",
      "אני שואל/ת את עצמי, בשקט: איך זה מרגיש כשאני נותן/ת לעצמי רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מאחורי חוסר חשק יש בקשה."
    ],
      [
      "מאחורי חוסר חשק יש בקשה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב בקשה אחת לעצמי.",
      "לכתוב בקשה אחת לעצמי."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חיבור קטן",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי."
    ],
      [
      "היום אני מחפש/ת חיבור קטן בתוכי.",
      "לא גדול, רק אפשרי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה נותן לי תחושת חיבור עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איזו מילה מרגיעה אותי?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לתת לעצמי לרגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "חיבור קטן גם הוא חיבור."
    ],
      [
      "חיבור קטן גם הוא חיבור."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שקטה בלב.",
      "מילה אחת שקטה בלב."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "חמלה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת."
    ],
      [
      "היום אני מדבר/ת עם עצמי בעדינות.",
      "לא כמו שופט/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איך הייתי מדבר/ת לחבר/ה במקום הזה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "אני שואל/ת את עצמי, בשקט: מה אני יכול/ה לסלוח לעצמי עליו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "עדינות לא מבטלת את חוסר החשק."
    ],
      [
      "עדינות לא מבטלת את חוסר החשק."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה פנימית",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה, רק בקשה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הבטן נרגעת מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה הבקשה הכי חשובה שלי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך לומר אותה במשפט אחד?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לעזור לי לנוע."
    ],
      [
      "בקשה אחת יכולה לעזור לי לנוע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך עדין",
    opening: localizedGenderNode(
      [
      "היום אני מזכיר/ה לעצמי ערך קטן שמחזיק אותי.",
      "לא גדול."
    ],
      [
      "היום אני מזכיר/ה לעצמי ערך קטן שמחזיק אותי.",
      "לא גדול."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לפנים רגועות.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך קטן חשוב לי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: איזה ערך קטן חשוב לי עכשיו?",
      "אני שואל/ת את עצמי, בשקט: איך הערך הזה נראה ביום רגיל?",
      "אני שואל/ת את עצמי, בשקט: מה צעד פנימי קטן שמכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך קטן נותן לי כיוון."
    ],
      [
      "ערך קטן נותן לי כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לבחור ערך אחד ולחזור עליו בלב.",
      "לבחור ערך אחד ולחזור עליו בלב."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "איך אני עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת."
    ],
      [
      "היום אני בודק/ת איך אני מתייחס/ת לעצמי.",
      "אני לא שופט/ת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לעצמי חצי דקה של שקט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: באיזה רגע אני נלחץ/ת מעצמי?",
      "אני שואל/ת את עצמי, בשקט: איפה אני יכול/ה להרפות קצת?",
      "אני שואל/ת את עצמי, בשקט: איך אני רוצה לדבר עם עצמי בעתיד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ],
      [
      "איך שאני איתי חשוב כמו כל דבר."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של כבוד לעצמי.",
      "משפט אחד של כבוד לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת שינוי קטן שאפשר להחזיק.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגוף יציב לרגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי היום?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה שינוי קטן יכול לעזור לי היום?",
      "אני שואל/ת את עצמי, בשקט: איך זה ייראה בפועל?",
      "אני שואל/ת את עצמי, בשקט: מה אני מוכן/ה לנסות פעם אחת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק זה מספיק."
    ],
      [
      "קטן מספיק זה מספיק."
    ]
    ),
    action: localizedGenderNode(
      "צעד אחד קטן לעצמי.",
      "צעד אחד קטן לעצמי."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי."
    ],
      [
      "היום אני מסיים/ת ברוך.",
      "אני בוחר/ת משפט שמחזיר אותי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה אוויר נכנס ויוצא.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על חוסר החשק הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ],
      [
      "אני שואל/ת את עצמי, בשקט: מה למדתי על חוסר החשק הזה?",
      "אני שואל/ת את עצמי, בשקט: מה הסימן המוקדם שהוא עולה?",
      "אני שואל/ת את עצמי, בשקט: איזה משפט מחזיר אותי לרגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ],
      [
      "אני בוחר/ת נוכחות לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת ומשפט החזרה שלי.",
      "נשימה אחת ומשפט החזרה שלי."
    ),
  },
].map(buildNormalizedDay);

export const lackOfDesireLackOfMotivationBlueprintHe = buildNormalizedPilotBlueprint({
  id: "lack_of_desire_lack_of_motivation_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "lack_of_desire_lack_of_motivation",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "חוסר חשק / חוסר מוטיבציה",
    en: "Lack of desire / lack of motivation",
    es: "Falta de ganas / falta de motivacion",
  },
  days,
});

export default lackOfDesireLackOfMotivationBlueprintHe;
